import { render, staticRenderFns } from "./Compulsas.vue?vue&type=template&id=01bbf9bc&scoped=true"
import script from "./Compulsas.vue?vue&type=script&lang=js"
export * from "./Compulsas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bbf9bc",
  null
  
)

export default component.exports